import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import {
  GetHelperPagesQueryParams,
  TudigoError,
  TudigoResponse,
} from "@tudigo-monorepo/core-tudigo-api";
import {
  HelperPages,
  isHelperPages,
} from "@tudigo-monorepo/core-tudigo-api-models";
import { QUERY_KEYS } from "@tudigo-monorepo/core-tudigo-utils";
import { getApiClient } from "@tudigo-monorepo/web-tudigo-api-client";

import { getQueryListKey } from "../../query-key-factory";

async function getHelperPagesImpl(params?: GetHelperPagesQueryParams) {
  const apiClient = getApiClient();

  const response = await apiClient.apiV1.helperPages.getHelperPages(params);

  const responseData = response.data;

  if (!isHelperPages(responseData.data)) {
    throw new Error(`Invalid HelperPages response data: ${responseData.data}`);
  }

  return responseData;
}

export function getHelperPagesQueryKey(params?: GetHelperPagesQueryParams) {
  return getQueryListKey({
    key: QUERY_KEYS.HELPER_PAGES,
    fields: params?.fields,
    filters: params?.filters,
  });
}

export const useGetHelperPagesQuery = (
  params?: GetHelperPagesQueryParams,
  options?: UseQueryOptions<TudigoResponse<HelperPages>, TudigoError>,
) =>
  useQuery({
    queryKey: getHelperPagesQueryKey(params),
    queryFn: () => getHelperPagesImpl(params ?? {}),
    ...options,
  });
